import { ChangeDetectorRef, Component, OnInit, ViewChild,inject, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { Observable, Subscription, combineLatest, finalize, map, mergeMap, of } from 'rxjs';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { Solution } from 'src/app/models/service/solution';
import { SolutionVersion } from 'src/app/models/service/solution-version';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { Blueprint, InstanceTabs } from 'src/app/models/blueprints/blueprint';
import { InstancesService } from 'src/app/services/api/instances.service';
import { Instance } from 'src/app/models/instance/instance';
import { Configuration } from 'src/app/models/configurations/configuration';
import { DeploymentClass } from 'src/app/models/instance-class';
import { UrlService } from 'src/app/services/util/url.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ReportIssueComponent } from '../../report-issue/report-issue.component';
import { ConfigurationsService } from 'src/app/services/api/configurations.service';
import { ConfigurationApplicationStatus, ConfigurationPackageStatus,
  ConfigurationState } from 'src/app/models/configurations/configuration-state';
import { Sort, SortDirection } from 'src/app/models/sort';
import { Constants } from 'src/app/models/constants';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { CRVTService } from 'src/app/services/api/crvt.service';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { isDate } from 'src/app/services/util/utils';
import { VerifypopupComponent } from 'src/app/components/verifypopup/verifypopup.component';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { MatDialog } from '@angular/material/dialog';
import { SkiptestPopupComponent } from 'src/app/components/skiptest-popup/skiptest-popup.component';
import { NotificationsService } from 'src/app/services/api/notifications.service';
import { ConfigurationDetailsComponent } from '../../configuration-details/configuration-details.component';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { ToastrService } from 'src/app/services/util/toastr.service';
import { ClipboardService } from 'ngx-clipboard';
import { Attributes, Datazone, Permission } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import cloneDeep from 'lodash/cloneDeep';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions } from 'src/app/models/principal/permission';
import { trigger, transition, style, animate } from '@angular/animations';
import {TenantsService} from 'src/app/services/api/tenants.service';
import { MonitoringService } from 'src/app/services/api/monitoring.service';

type ComparatorFunc = (first: any, second: any) => number;

const UPDATED_REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_NONPII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_PII,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_READ_DATAZONE_LIVE,
    action: Permissions.INSTANCE_READ,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
];

const REQUIRED_PERMISSIONS: Permission[] = [
  Permission.APPLY_RELEASE_PACKAGE_HOTFIX,
  Permission.APPLY_RELEASE_PACKAGE_TILL_TEST,
  Permission.APPLY_RELEASE_PACKAGE
];

@Component({
    selector: 'app-instance-details',
    templateUrl: './instance-details.component.html',
    styleUrls: ['./instance-details.component.scss'],
    animations: [
        trigger('rotate', [
            transition('void=>*', [style({ transform: 'rotate(0)' })]),
            transition('* => *', [
                style({ transform: 'rotate(0)' }),
                animate('650ms ease-in-out', style({ transform: 'rotate(360deg)' })),
            ])
        ]),
        trigger('donutAnimation', [
            transition(':enter', [
                style({ transform: 'scale(0.8)', opacity: 0 }),
                animate('600ms ease-out', style({ transform: 'scale(1)', opacity: 1 }))
            ])
        ])
    ],
    standalone: false
})
export class InstanceDetailsComponent implements OnInit {
  @ViewChild('paginator', { static: true }) paginator: PaginatorComponent;
  @ViewChild('rvtPaginator', { static: true }) rvtPaginator: PaginatorComponent;
private destroyRef = inject(DestroyRef);
  RouterSegments = RouterSegments;
  InstanceTabs = InstanceTabs;
  breadcrumbItems: BreadcrumbItem[];
  tenant: string;
  service: Solution;
  serviceVersions: SolutionVersion[];
  blueprint: Blueprint;
  instance: Instance;
  isLoading = false;
  isOverview = true;
  isMonitoring = false;
  isEndpoints = false;
  configurations: Configuration[];
  buildNumber: string;
  releaseVersion: any;
  isAMR: boolean;
  isReleasePack = false;
  isRvtPack = false;

  configurationStates: ConfigurationState[];
  configuration: Configuration[];
  pageConfigurationStates: ConfigurationState[];
  filteredConfigurationStates: ConfigurationState[];

  Constants = Constants;
  ConfigurationApplicationStatus = ConfigurationApplicationStatus;
  ConfigurationPackageStatus = ConfigurationPackageStatus;
  DataZone = DataZone;

  configurationsMap: KeyValueMap<string, Configuration>;
  searchTerm: string;

  SortDirection = SortDirection;
  sort: Sort;

  configStateVerify = false;
  allInstances: Instance[];
  skipTest: boolean;
  loadDataSubscription: Subscription;
  instanceBlueprint: Instance[];
  deployedDate = new Date();
  currentDate = new Date();
  availableConfigurations: Configuration[];
  applyConfigInProgress = false;
  appliedConfigurationState: ConfigurationState;
  appliedRvtState: any;
  selectedTab = 0;
  isVerifying = false;
  filterOptions: any = [
    {
      label: 'All',
      value: ''
    },
    {
      label: 'Success',
      value: ['success']
    },
    {
      label: 'Failed',
      value: ['test_failed', 'configure_failed', 'failed']
    }
  ];

  selectedFilter: any =  {
    label: 'All',
    value: ''
  };

  MonitoringRow: any =  [
    {
      category: 'Infra Monitoring',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['nginx', 'keycloak', 'azcopy', 'azcopy-dr', 'infkeycloak']
    },
    {
      category: 'Interfaces',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['activemq', 'artemis', 'kafka', 'activemqext', 'artemismq', 'bass-switchfileprocessing', 'interfaces']
    },
    {
      category: 'Transact',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['transact', 'autoscale']
    },
    {
      category: 'DES',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['des']
    },
    {
      category: 'FCM',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['fcm']
    },
    {
      category: 'Digital',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['fabric']
    },
    {
      category: 'DSF',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['dsf']
    },
    {
      category: 'Wealth',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['wealth/wealth-des/wealthinflux']
    },
    {
      category: 'TDE',
      monitoringType: 'Kubernetes namespace',
      monitoringEntity: ['tde/tdesql/sql/tde-mqsql/tde-atlas/tde-grafana/tde-graphite/tde-portal/tde-spark/tdh-azcopy/tdh-azcopy1']
    }
  ]

  nonProdZone: any;

  allConfigurationStates: ConfigurationState[] = [];
  istanceLoaded = false;
  configurationLoaded = false;
  copy = false;
  releaseManager = false;
  permissionsMap: { [key: string]: boolean };
  Permission = Permission;
  allRvtStates: any;
  selectedRvtFilter = {
    label: 'All',
    value: ''
  };
  rvtStates: any;
  filteredRvtStates: any;
  rvtSearchTerm: any;
  pageRvtStates: any;
  rvtSort: any;
  selectedRvtTab = 0;
  configurationsForRvt: any;
  executeRvtInProgress = false;

  DeploymentClass = DeploymentClass;
  rvtResultsLoaded = false;
  configResultsLoaded = false;
  updatedPermissionsMap: { [key: string]: boolean };
  count: number;
  defaultState: boolean;
  isExternalClient: boolean;
  activeStatus = 'HEALTHY';
  selectedItem: any = null;
  searchKey: any;
  filteredMonitoringTable: any;
  noMonitoringData = false;
  donutAnimationState = 0;
  tenantName: any;

  constructor(private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private solutionsService: SolutionsService,
    private errorPageService: ErrorPageService,
    private blueprintsService: BlueprintsService,
    private instanceService: InstancesService,
    private toastrService: ToastrService,
    private urlService: UrlService,
    private sidenavService: SidenavService,
    private configService: ConfigurationsService,
    private crvtService: CRVTService,
    private changeDetectorRef: ChangeDetectorRef,
    private matDialog: MatDialog,
    private notificationsService: NotificationsService,
    private solutionVersionsService: SolutionVersionsService,
    private clipboardApi: ClipboardService,
    private permissionsService: PermissionsService,
    private tenantsService: TenantsService,
    private monitoringService: MonitoringService,
    private router: Router) {
    }

  ngOnInit(): void {
    this.updatedPermissionsMap = this.permissionsService.resolveAPIPermissions(UPDATED_REQUIRED_PERMISSIONS);
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    this.subscribeForNotifications();
    this.tenant = this.authService.principal.provider;
    this.releaseManager = this.authService.hasPermission(Permission.APPLY_RELEASE_PACKAGE_HOTFIX);
      this.breadcrumbItems = [];
    this.breadcrumbItems.push({ label: 'Home', url: [] });
    // this.breadcrumbItems.push({ label: translate('CATALOGUE.CATALOGUE'), url: ['catalogue'] });
    this.loadService();
    this.gettenant();
    this.paginator?.page
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(pageEvent => {
      this.applyPaginator();
    });

    this.rvtPaginator?.page
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(pageEvent => {
      this.applyRvtPaginator();
    });
  }

  /**
   * Get tenant
   * Verify tenant origin
   */
  gettenant() {
      this.tenantsService.getTenant(this.tenant)
     .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((tenant: any) => {
        this.tenantName = tenant.tenantId;
        if (tenant?.origin.toLowerCase() === 'external') {
          this.isExternalClient = true;
        } else {
          this.isExternalClient = false;
        }
      });
  }

  /**
   * Goes to selected tab when tab selection changes
   * @param - the section name of selected tab
   */
  gotoSection(section: string): void {
    switch (section) {
      case this.InstanceTabs.OVERVIEW:
        this.isOverview = true;
        this.isMonitoring = false;
        this.isEndpoints = false;
        this.isReleasePack = false;
        this.isRvtPack = false;
        break;
      case this.InstanceTabs.MONITORING:
        this.isOverview = false;
        this.isMonitoring = true;
        this.isEndpoints = false;
        this.isReleasePack = false;
        this.isRvtPack = false;
        this.donutAnimationState++;
        break;
      case this.InstanceTabs.VIEW_ENDPOINTS:
        this.isOverview = false;
        this.isMonitoring = false;
        this.isEndpoints = true;
        this.isReleasePack = false;
        this.isRvtPack = false;
        break;
      case this.InstanceTabs.RELEASE_PACKAGE:
        const instance = this.allInstances?.find(item => item.id === this.instance.id);
        this.updateInstance(instance, this.instance?.latestConfigurationState?.status);
        this.isMonitoring = false;
        this.isOverview = false;
        this.isEndpoints = false;
        this.isRvtPack = false;
        break;
      case this.InstanceTabs.RVT_PACKAGE:
        this.updateInstanceForRvt();
        this.isOverview = false;
        this.isMonitoring = false;
        this.isEndpoints = false;
        this.isReleasePack = false;
        this.isRvtPack = true;
        break;
      default:
        break;
    }
  }

  // Displays copied icon after URL copied
  onCopyId(data): void {
    this.copy = true;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.copy = false;
    }, 500);
  }

  /**
   * Opens URL in separate tab when URL is clicked
   * @param - the URL which is clicked
   */
  navigateToUrl(url): void {
    this.urlService.openUrlInNewTab(url);
  }

  // Reports issue when endpoints not available
  openContactForm(): void {
    this.isLoading = true;
    const data: any = {
      title: translate('INSTANCE_SUMMARY.REPORT_ISSUE.TITLE'),
      subtitle: '',
      report: {
        service: this.service,
        blueprint: this.blueprint,
        instance: this.instance
      },
      buildNumber: this.buildNumber
    };
    combineLatest([this.blueprintsService.getBlueprintsIdLatestVersion(this.blueprint.id),
      this.configService.getConfigurations(this.blueprint.id)])
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(([blueprint, configurations]) => {
      this.instance.activeConfiguration = configurations.find(item => item.id === this.instance.configurationId);
      data.report.instance = this.instance;
      data.version = blueprint.version;
      data.configurations = configurations;
      this.isLoading = false;
      this.sidenavService.openInRightSidenav(ReportIssueComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
    }, (err) => this.errorPageService.show404Page());
  }

  /**
   * Goes to selected tab when tab selection changes in release package page
   * @param - the section name of selected tab
   */
  public tabChange(event): void {
    this.selectedTab = event;
    if (event === 1) {
      this.loadConfigurations();
    }
  }

  public rvtTabChange(event): void {
    this.selectedRvtTab = event;
    if (event === 1) {
      this.loadRvtStates();
    }
  }

  /**
   * Filter the configuration results according to search term and sort them
   */
  filterRows(): void {
    // Remove all configuration states
    if (this.filteredConfigurationStates) {
      this.filteredConfigurationStates.splice(0, this.filteredConfigurationStates.length);
    }

    if (this.configurationStates?.length > 0) {
      this.configurationStates.forEach( configState => {
        this.configurations.forEach( config => {
          if(configState.configurationId === config.id){
            if(config?.manifest?.code) {
              configState.codeResult = config.manifest.code;
            }
          }
        });
      });
      this.filteredConfigurationStates = [...this.configurationStates]
      .sort(this.propertyComparator('applicationFinishTime',SortDirection.DESC))
      .filter(configurationState => Constants.CONFIGURATION_FINAL_STATES.includes(configurationState.status));
    }


    if (this.searchTerm != null) {
      const searchBy = this.searchTerm.trim().toLocaleLowerCase();
      this.filteredConfigurationStates = this.filteredConfigurationStates?.filter(configurationState =>
          configurationState.status?.toLocaleLowerCase().includes(searchBy)
          || this.configurationsMap[configurationState.configurationId].manifest.name.toLocaleLowerCase().includes(searchBy)
          || this.configurationsMap[configurationState.configurationId].manifest.version.toLocaleLowerCase().includes(searchBy));
    }
    this.paginator.length = this.filteredConfigurationStates?.length;
  }

  filterRvtRows(): void {
    // Remove all configuration states
    if (this.filteredRvtStates) {
      this.filteredRvtStates.splice(0, this.filteredRvtStates.length);
    }

    if (this.rvtStates?.length > 0) {
      this.rvtStates.forEach( configState => {
        this.configurations.forEach( config => {
          if(configState.configurationId === config.id){
            if(config?.manifest?.code) {
              configState.codeResult = config.manifest.code;
            }
          }
        });
      });
      this.filteredRvtStates = [...this.rvtStates]
      .sort(this.propertyComparator('applicationFinishTime',SortDirection.DESC))
      .filter(rvtState => Constants.CONFIGURATION_FINAL_STATES.includes(rvtState.status));
    }

    if (this.rvtSearchTerm != null) {
      const searchBy = this.rvtSearchTerm.trim().toLocaleLowerCase();
      this.filteredRvtStates = this.filteredRvtStates.filter(rvtState =>
          rvtState.status?.toLocaleLowerCase().includes(searchBy)
          || this.configurationsMap[rvtState.configurationId].manifest.name.toLocaleLowerCase().includes(searchBy)
          || this.configurationsMap[rvtState.configurationId].manifest.version.toLocaleLowerCase().includes(searchBy));
    }
    this.rvtPaginator.length = this.filteredRvtStates?.length;
  }

  /**
   * Opens the selected result in separate tab for viewing
   * @param - the selected configuration state and file name
   */
  viewTestResults(configurationState: ConfigurationState, filename: string): void {
    const configuration = this.configurationsMap[configurationState.configurationId];
    this.crvtService.getViewResultsUrl(configuration.blueprintId, configurationState.instanceId, configurationState.id, filename)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((viewUrl) => {
      this.urlService.openUrlInNewTab(viewUrl);
    });
  }

  /**
   * Downloads the selected result
   * @param - the selected configuration state and file name
   */
  downloadTestResults(configurationState: ConfigurationState, filename: string): void {
    const configuration = this.configurationsMap[configurationState.configurationId];
    this.crvtService.downloadCRVT(configuration.blueprintId, configurationState.instanceId, configurationState.id, filename)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  /**
   * Calls filter function when search term changes
   * @param - the search term entered
   */
  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
    this.filterRows();
  }

  searchRvt(searchTerm?: string): void {
    this.rvtSearchTerm = searchTerm;
    this.filterRvtRows();
  }

  doRvtSort(property: string): void {
    if (!this.rvtSort || this.rvtSort.property !== property) {
      this.rvtSort = {
        property,
        direction: SortDirection.ASC
      };
    } else if (this.rvtSort.direction === SortDirection.ASC) {
      this.rvtSort.direction = SortDirection.DESC;
    } else {
      this.rvtSort = null;
    }

    if (!this.rvtSort) {
      this.filteredRvtStates = this.filteredRvtStates.sort(this.propertyComparator('applicationFinishTime',
        SortDirection.DESC));
    } else if (this.rvtSort.property === 'duration') {
      this.filteredRvtStates = this.filteredRvtStates.sort(this.durationComparator(this.rvtSort.direction));
    } else {
      this.filteredRvtStates = this.filteredRvtStates.sort(this.propertyComparator(this.rvtSort.property,
        this.rvtSort.direction));
    }
    this.applyRvtPaginator();
  }

  /**
   * Sorts the configuration states
   * @param - the column property to sort
   */
  doSort(property: string): void {
    if (!this.sort || this.sort.property !== property) {
      this.sort = {
        property,
        direction: SortDirection.ASC
      };
    } else if (this.sort.direction === SortDirection.ASC) {
      this.sort.direction = SortDirection.DESC;
    } else {
      this.sort = null;
    }

    if (!this.sort) {
      this.filteredConfigurationStates = this.filteredConfigurationStates.sort(this.propertyComparator('applicationFinishTime',
        SortDirection.DESC));
    } else if (this.sort.property === 'duration') {
      this.filteredConfigurationStates = this.filteredConfigurationStates.sort(this.durationComparator(this.sort.direction));
    } else {
      this.filteredConfigurationStates = this.filteredConfigurationStates.sort(this.propertyComparator(this.sort.property,
        this.sort.direction));
    }
    this.applyPaginator();
  }


  /**
   * Calls get available configurations function when apply is clicked for a package
   * @param - the instance of selected cofiguration
   */
  updateInstance(instance: Instance, configStatus): void {
    this.availableConfigurations = this.getAvailableConfigurations(instance);
    this.isReleasePack = true;
  }

  updateInstanceForRvt(): void {
    const configurations = cloneDeep(this.configurations);
    this.configurationsForRvt = configurations?.filter(config => config?.manifest?.test);
    this.allRvtStates?.sort((state1, state2) => state2.applicationStartTime.getTime() - state1.applicationStartTime.getTime());
    this.instance.rvtStates = this.allRvtStates;
    if (this.instance.rvtStates?.length > 0) {
      this.instance.latestRvtState = this.instance.rvtStates[0];
    }
    this.configurationsForRvt?.forEach(config => {
      config.status = this.allRvtStates?.find(item => item.configurationId === config.id)?.status;
    });
  }

  rvtFilterOptionChange(option): void {
    this.selectedRvtFilter = option;
    if (option.value) {
      this.rvtStates = this.allRvtStates.filter(item => option.value.includes(item?.status)) || [];
    } else {
      this.rvtStates = this.allRvtStates || [];
    }
    this.filterRvtRows();
  }

  /**
   * Filters configuration states when filter options changes
   * @param - the option selected in filter
   */
  filterOptionChange(option): void {
    this.selectedFilter = option;
    if (option.value) {
      this.configurationStates = this.allConfigurationStates.filter(item => option.value.includes(item?.status)) || [];
    } else {
      this.configurationStates = this.allConfigurationStates || [];
    }
    this.filterRows();
  }

  /**
   * Redirects to view or download function when configuration name is clicked
   * @param - the selected configuration state
   */
  configurationNameClick(configurationState: any): void {
    const dialogRef =  this.matDialog.open(ConfigurationDetailsComponent, {
      height: '60vh',
      width: '80vw',
      panelClass: 'flex-dialog',
      data: {
        results: true,
        configurationState,
        configuration: this.configurations.find(item => item.id === configurationState.configurationId),
        isRvt: this.isRvtPack
      }
    })
    const instance = dialogRef.componentInstance;
    instance.actionPerformed
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((data) => {
        if (data?.type === 'download') {
          this.downloadTestResults(data?.configuration, data?.resultsReportFile);
        } else if (data?.type === 'view') {
          this.viewTestResults(data?.configuration, data?.resultsReportFile);
        }
      });
  }

  /**
   * Redirects to apply configuration function when configuration name is clicked
   * @param - the selected configuration
   */
  public applyConfigClick(configuration): void {
    if (this.instance?.dataZone === DataZone.LIVE && !this.configStateVerify &&
      configuration.status !== ConfigurationApplicationStatus.VERIFIED) {
      this.matDialog.open(VerifypopupComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog',
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
          if (data) {
            const dataVerify = localStorage.getItem('verifyUpdate');
            if(configuration.status === ConfigurationApplicationStatus.VERIFIED) {
              this.configStateVerify = true;
            }
            if (dataVerify === 'true') {
              this.verifyConfiguration(configuration.id, this.instance.id);
            }
            else if(dataVerify === 'false') {
              this.applyConfiguration(configuration.id, this.instance.id, configuration);
            }
          }
      });
    } else {
      this.applyConfiguration(configuration.id, this.instance.id, configuration);
    }
  }

  public executeRvtClick(configuration): void {
    this.executeRvtInProgress = true;
    this.instanceService.executeRVTState(configuration.id, this.instance.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadData();
      },
      (error) => {
        this.executeRvtInProgress = false;
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.EXCECUTE_RVT_FAILED'),
            description: error,
          }
        });
      });
  }

  // Gets solution details based on service id and adds in breadcrumbs
  private loadService(): void {
    const serviceId = this.activatedRoute.snapshot.params.serviceId;
    combineLatest([this.solutionsService.getSolutionDetailsById(serviceId), this.solutionsService.getSolutionVersions(serviceId)])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([service, serviceVersions]) => {
        this.service = service;
        this.serviceVersions = serviceVersions;
        // this.breadcrumbItems.push({ label: service.name, url: ['services', service.id] });
        this.loadInstances();
      }, (err) => this.errorPageService.show404Page());
  }

  // Gets blueprint details based on blueprint id and sets environment for instance
  private loadBlueprint(): void {
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.blueprintsService.getBlueprint(blueprintId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprint => {
        this.blueprint = blueprint;
        if (this.instance?.deploymentClass === DeploymentClass.D) {
          this.instance.environment = 'DEV';
        } else {
          this.instance.environment = this.blueprint?.pathToLiveConfiguration
            .find(item => item?.instanceId === this.instance?.id)?.environment;
        }
        this.breadcrumbItems.push({ label: this.blueprint.name, url: ['services', this.service.id, 'blueprints', this.blueprint.id] });
        this.breadcrumbItems.push({ label: this.instance.name });
        this.istanceLoaded = true;
        this.loadData(true);
      }, (err) => this.errorPageService.show404Page());
  }

  // Gets instance details based on instance id and sets build number by matching id with service version
  private loadInstances(): void {
    const instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.instanceService.getInstancesForSolution(this.service.id)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instances: any) => {
        this.instance = instances.find(item => item.id === instanceId);
        if ((this.instance?.dataZone === DataZone.DEVELOPMENT && !this.updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_NONPII])
          || (this.instance?.dataZone === DataZone.SECURE && !this.updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_PII])
          || (this.instance?.dataZone === DataZone.LIVE && !this.updatedPermissionsMap[PermissionKeys.INSTANCE_READ_DATAZONE_LIVE])) {
          this.router.navigate(['/', this.tenant, RouterSegments.UNAUTHORIZED], {skipLocationChange: true});
        }
        if (this.instance?.status === DeployStatus.TERMINATING || this.instance?.status === DeployStatus.TERMINATED) {
          this.errorPageService.show404Page();
        }
        this.releaseVersion = this.serviceVersions.find(version => version.id === this.instance?.solutionVersionId)?.releaseVersion;
        if(this.releaseVersion && this.solutionVersionsService.releaseVersion(this.releaseVersion)) {
          this.isAMR = true;
        }
        this.buildNumber = this.serviceVersions.find(version => version.id === this.instance?.solutionVersionId)?.version;
        this.loadBlueprint();
        this.loadMonitoring();
      }, (err) => this.errorPageService.show404Page());
  }

  loadMonitoring(): void {
  this.monitoringService.getRagStatus(this.tenantName)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      if (!data?.managementZones || data.managementZones.length === 0) {
        this.noMonitoringData = true;
        this.nonProdZone = null;
        this.selectedItem = null;
        this.filteredMonitoringTable = [];
        this.isLoading = false;
        return;
      }
      this.noMonitoringData = false;
      const zones = data?.managementZones?.map(zone => {
        const summary = this.summarizeZone(zone);
        return {
          name: zone.managementZone,
          services: summary.services,
          healthy: summary.healthy,
          critical: summary.critical,
          impacted: summary.impacted,
          overallStatus: this.getOverallStatus(summary),
          details: zone.rag_list
        };
      });
      this.searchKey = this.instance?.randomSuffix;
      if(!this.isExternalClient) {
        this.nonProdZone = zones?.find(item =>item.name.toLowerCase().includes(this.searchKey?.toLowerCase()) );
      } else {
        this.nonProdZone = zones?.find(item => {
          const zonePart = item.name.split(':')[0].trim().toLowerCase();
          return zonePart.endsWith(this.instance?.name?.toLowerCase());
        });
      }
      if (this.nonProdZone) {
        this.nonProdZone.donutStyle = this.getDonutStyle(this.nonProdZone);
        this.selectFirstItem();
      }
      this.isLoading = false;
    });
  }

  selectFirstItem(): void {
  const filteredItems = this.nonProdZone?.details.filter(
    item => this.ragToStatus(item.rag) === this.activeStatus
  );
  if (filteredItems?.length) {
    this.selectItem(filteredItems[0]);
  }
}

  summarizeZone(zone: any) {
    const summary = {
      services: zone.rag_list.length,
      healthy: 0,
      critical: 0,
      impacted: 0
    };
    zone.rag_list.forEach(item => {
      switch (item.rag) {
        case 'GREEN':
          summary.healthy++;
          break;
        case 'AMBER':
          summary.impacted++;
          break;
        case 'RED':
          summary.critical++;
          break;
      }
    });
    return summary;
  }

  getOverallStatus(summary: any): any {
    if (summary.impacted > 0) {
      return 'IMPACTED';
    }
    if (summary.critical > 0) {
      return 'CRITICAL';
    }
    return 'HEALTHY';
  }


ragToStatus(rag: string): any {
  switch (rag) {
    case 'GREEN': return 'HEALTHY';
    case 'AMBER': return 'IMPACTED';
    case 'RED': return 'CRITICAL';
  }
}

getFilteredItems(zone: any) {
  return zone.details.filter(
    item => this.ragToStatus(item.rag) === this.activeStatus
  );
}

onStatusChange(status): void {
  this.activeStatus = status;
  this.selectedItem = null;
  this.filteredMonitoringTable = [];
  this.selectFirstItem();
}

selectItem(item: any) {
  this.selectedItem = item;
  const matchedRow = this.MonitoringRow.find(row =>
    row.category.toLowerCase().includes(this.selectedItem.product.toLowerCase())
  );
  this.filteredMonitoringTable = matchedRow ? [matchedRow] : [];
  }

getDonutStyle(zone: any) {
  const total = zone.services ?? 0;
  if (total === 0) {
    return {
      background: `conic-gradient(#d3d3d3 0deg 360deg)`
    };
  }
  const healthy = zone.healthy ?? 0;
  const impacted = zone.impacted ?? 0;
  const critical = zone.critical ?? 0;

  const healthyDeg = (healthy / total) * 360;
  const impactedDeg = (impacted / total) * 360;
  const criticalDeg = (critical / total) * 360;

  const hEnd = healthyDeg;
  const iEnd = hEnd + impactedDeg;
  const cEnd = iEnd + criticalDeg;

  return {
    background: `conic-gradient(
      #188038 0deg ${hEnd}deg,
      #EF7839 ${hEnd}deg ${iEnd}deg,
      #B53B20 ${iEnd}deg ${cEnd}deg
    )`
  };
}


  // Loads configuration states list according to selected filter
  private loadConfigurations(): void {
    if (this.selectedFilter.value) {
      this.configurationStates = this.allConfigurationStates.filter(item => this.selectedFilter.value.includes(item?.status)) || [];
    } else {
      this.configurationStates = this.allConfigurationStates || [];
    }
    this.configurationsMap = this.configurations?.reduce((acc, configuration) => {
      acc[configuration.id] = configuration;
      return acc;
    }, {});
    this.filterRows();
  }

  private loadRvtStates(): void {
    if (this.selectedRvtFilter.value) {
      this.rvtStates = this.allRvtStates.filter(item => this.selectedRvtFilter.value.includes(item?.status)) || [];
    } else {
      this.rvtStates = this.allRvtStates || [];
    }
    this.configurationsMap = this.configurations?.reduce((acc, configuration) => {
      acc[configuration.id] = configuration;
      return acc;
    }, {});
    this.filterRvtRows();
  }

  // Shows configuration states according to page selection
  private applyPaginator(): void {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    this.pageConfigurationStates = this.filteredConfigurationStates?.slice(startIndex, startIndex + this.paginator.pageSize);
    this.pageConfigurationStates?.filter((item) => {
      const patchValue = parseInt(item?.manifest?.version.split('.').pop(), 10);
      if(patchValue > 0) {
        item.hotfix = true;
      }
    });
    this.changeDetectorRef.detectChanges();
  }

  private applyRvtPaginator(): void {
    const startIndex = this.rvtPaginator.pageIndex * this.rvtPaginator.pageSize;
    this.pageRvtStates = this.filteredRvtStates?.slice(startIndex, startIndex + this.rvtPaginator.pageSize);
    this.changeDetectorRef.detectChanges();
  }

  /**
   * Sorts configuration states
   * @param - the property and direction to sort
   */
  private propertyComparator(property: string, direction: SortDirection): ComparatorFunc {
    return (configurationState1: ConfigurationState, configurationState2: ConfigurationState): number => {
      if (isDate(configurationState1[property])) {
        return direction === SortDirection.ASC
        ? configurationState1[property]?.getTime() - configurationState2[property]?.getTime()
        : configurationState2[property]?.getTime() - configurationState1[property]?.getTime();
      } else {
        if (configurationState1[property] && configurationState2[property]) {
          return direction === SortDirection.ASC
            ? configurationState1[property].localeCompare(configurationState2[property])
            : -(configurationState1[property].localeCompare(configurationState1[property]));
        }
      }
    };
  }

  /**
   * Sorts configuration states for time related column
   * @param - the direction to sort
   */
  private durationComparator(direction: SortDirection): ComparatorFunc {
    return (configurationState1: ConfigurationState, configurationState2: ConfigurationState): number => {
      if (configurationState1.applicationStartTime && configurationState1.applicationFinishTime
        && configurationState2.applicationStartTime && configurationState2.applicationFinishTime) {
          const duration1 = new Date(configurationState1.applicationFinishTime).getTime()
            - new Date(configurationState1.applicationStartTime).getTime();

          const duration2 = new Date(configurationState2.applicationFinishTime).getTime()
            - new Date(configurationState2.applicationStartTime).getTime();

          return direction === SortDirection.ASC ? duration1 - duration2 : duration2 - duration1;
      }
      return 0;
    };
  }

  /**
   * Populates available configurations according to selected instance
   * @param - the instance selected
   */
  private getAvailableConfigurations(instance: Instance): Configuration[] {
    const requiredEnvironment = this.blueprint?.pathToLiveConfiguration.find(
      ptl => ptl.environment === instance?.environment && ptl.instanceId === instance.id)?.requires;
    let availableConfigurations = this.configurations;
    // Only configurations which are created before (or equal) latest successfully applised configuration on previous environment
    const prodInstance = this.allInstances?.find(instances => instances.id === this.instance.id);
    if (this.instance?.dataZone === DataZone.LIVE &&
      prodInstance?.configurationStates?.find(config => config.status === ConfigurationApplicationStatus.VERIFIED)) {
      const latestVerifiedInstance = prodInstance.configurationStates
        .find(configurationState => configurationState.status === ConfigurationApplicationStatus.VERIFIED);
      const verifiedInstanceConfig =
        this.getConfigurationById(latestVerifiedInstance.configurationId);
      availableConfigurations = availableConfigurations
        .filter(configuration => configuration.dateCreated === verifiedInstanceConfig.dateCreated);
      } else if((this.releaseManager && (instance?.environment === translate('CONFIGURATIONS.STATE.PREPROD')) && requiredEnvironment)) {
        const requiredInstance = this.allInstances.find(ptlInstance => ptlInstance.environment === requiredEnvironment);
        if(instance?.environment === translate('CONFIGURATIONS.STATE.PREPROD')) {
          availableConfigurations = [];
          this.configurations.filter((item) => {
            if(instance.latestConfigurationState) {
              const instanceValue = parseInt(instance?.latestConfigurationState?.manifest?.version.split('.').shift());
              const originalValue = parseInt(item.manifest.version.split('.').shift());
              if(instanceValue === originalValue) {
                const patchValue = parseInt(item.manifest.version.split('.').pop(), 10);
                if(patchValue > 0) {
                  availableConfigurations.push(item);
                }
              }
            }
          });
        }
        if (requiredInstance?.configurationStates) {
          const latestSuccessfulStateOfRequiredInstance = requiredInstance.configurationStates
            .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
          if (latestSuccessfulStateOfRequiredInstance) {
            const configAvailable = this.configurations;
            const latestAppliedConfigurationOnRequiredInstance =
              this.getConfigurationById(latestSuccessfulStateOfRequiredInstance.configurationId);
              for(const configStates of requiredInstance.configurationStates) {
                if (configStates.status === ConfigurationApplicationStatus.SUCCESS) {
                  for(const availableConfig of configAvailable) {
                    if(availableConfig.id === configStates.configurationId) {
                      availableConfigurations.push(availableConfig);
                    };
                    availableConfigurations = [...new Set(availableConfigurations)];
                  }
                }
              }
          };
        }
    } else if (requiredEnvironment) {
      const requiredInstance = this.allInstances?.find(ptlInstance => ptlInstance.environment === requiredEnvironment);
      if (requiredInstance?.configurationStates) {
        const latestSuccessfulStateOfRequiredInstance = requiredInstance.configurationStates
          .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
        if (latestSuccessfulStateOfRequiredInstance) {
          const configAvailable = availableConfigurations;
          const latestAppliedConfigurationOnRequiredInstance =
            this.getConfigurationById(latestSuccessfulStateOfRequiredInstance.configurationId);
            if (requiredEnvironment === translate('CONFIGURATIONS.STATE.PREPROD')) {
              availableConfigurations = latestAppliedConfigurationOnRequiredInstance ? [latestAppliedConfigurationOnRequiredInstance] : [];
            } else {
            availableConfigurations = [];
            for(const configStates of requiredInstance.configurationStates) {
              if (configStates.status === ConfigurationApplicationStatus.SUCCESS) {
                for(const availableConfig of configAvailable) {
                  if(availableConfig.id === configStates.configurationId) {
                    availableConfigurations.push(availableConfig);
                  }
                  availableConfigurations = [...new Set(availableConfigurations)];
                }
              }
            }
          }
          const latestVersion = latestAppliedConfigurationOnRequiredInstance?.manifest?.version;
          if (latestVersion && requiredEnvironment !== 'PREPROD') {

            const [latestMajor, latestMinor] = latestVersion.split('.').map(num => parseInt(num, 10));

            availableConfigurations = this.configurations.filter(item => {
              const [major, minor, patch] = item.manifest.version.split('.').map(num => parseInt(num, 10));
              // version is less than selected major.minor
              const isLowerVersion = major < latestMajor || (major === latestMajor && minor < latestMinor);
              // version belongs to same major.minor (hotfixes)
              const isHotfix = major === latestMajor && minor === latestMinor;
              return isLowerVersion || isHotfix;
            });
          }
          availableConfigurations.sort((a, b) => {
            const asort = a.manifest.version.split('.').map(num => parseInt(num, 10));
            const bsort = b.manifest.version.split('.').map(num => parseInt(num, 10));

            for (let i = 0; i < 3; i++) {
              if (asort[i] > bsort[i]) return 1;
              if (asort[i] < bsort[i]) return -1;
            }
            return 0;
          });
        } else {
          availableConfigurations = [];
        }
      } else {
        availableConfigurations = [];
      }
    }
    if (instance?.configurationStates) {
      const latestSuccessfulState = instance.configurationStates
        .find(configurationState => configurationState.status === ConfigurationApplicationStatus.SUCCESS);
      if (latestSuccessfulState) {
        const latestAppliedConfiguration = this.getConfigurationById(latestSuccessfulState.configurationId);
        availableConfigurations = availableConfigurations
          .filter((configuration:any) =>
            this.compareVersions(configuration.version, latestAppliedConfiguration.version) > 0 );
      }
    }
    if(availableConfigurations?.length > 0) {
          availableConfigurations.sort((a, b) => {
            const asort = a.manifest.version.split('.').map(num => parseInt(num, 10));
            const bsort = b.manifest.version.split('.').map(num => parseInt(num, 10));

            for (let i = 0; i < 3; i++) {
              if (asort[i] > bsort[i]) return 1;
              if (asort[i] < bsort[i]) return -1;
            }
            return 0;
          });
        }
    return availableConfigurations;
  }

  compareVersions(version: string, latestVersion: string): number {
    const version1 = version.split('.').map(num => parseInt(num, 10));
    const version2 = latestVersion.split('.').map(num => parseInt(num, 10));
    for (let i = 0; i < Math.max(version1.length, version2.length); i++) {
      if (version1[i] > version2[i]) return 1;
      if (version1[i] < version2[i]) return -1;
    }
    return 0;
  }
  /**
   * Returns configuration corresponding to given configuration id
   * @param - the configuration id
   */
  private getConfigurationById(configurationId: string): Configuration {
    return this.configurations.find(configuration => configuration.id === configurationId);
  }

 /**
  * Opens popup for skipping test user input when apply button clicked
  * @param - the configuration id and instance id
  */
  private applyConfiguration(configurationId: string, instanceId: string, config?): void {
    if (this.allInstances.find(instance => instance.id === instanceId).deploymentClass !== DeploymentClass.A) {
      this.matDialog.open(SkiptestPopupComponent, {
        minHeight: '342px',
        width: '566px',
        panelClass: 'flex-dialog',
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.applyConfigInProgress = true;
          data.skipTest = !data.skipTest;
          this.skipTest = data.skipTest;

          this.applyConfigurationBasedOnInstance(configurationId, instanceId, this.skipTest);
        }
      });
    } else {
      this.skipTest = this.allInstances.find(instance => instance.id === instanceId).deploymentClass === DeploymentClass.A ? true : false;
      this.applyConfigurationBasedOnInstance(configurationId, instanceId, this.skipTest);
    }
  }

  /**
   * Applies selected configuration
   * @param - the configuration id, instance id and skip test value
   */
  private applyConfigurationBasedOnInstance(configurationId, instanceId, skipTest): void {
    this.configService.applyConfiguration(configurationId, instanceId, skipTest)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.loadData();
      },
      (error) => {
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.APPLY_CONFIGURATION_FAILED'),
            description: error,
          }
        });
      });
  }

  /**
   * Verifies selected configuration
   * @param - the configuration id and instance id
   */
  private verifyConfiguration(configurationId: string, instanceId: string): void {
    this.configService.verifyConfiguration(configurationId, instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.isVerifying = true;
        this.loadData();
      },
      (error) => {
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.APPLY_CONFIGURATION_FAILED'),
            description: error,
          }
        });
      });
  }

  // Loads all the configurations and configuration states
  private loadData(initialLoad?): void {
    this.configurationLoaded = false;
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
      this.loadDataSubscription = null;
    }

    if (this.isRvtPack && !initialLoad) {
      this.getRvtStates();
    }
    if (this.isReleasePack || initialLoad) {
      this.loadDataSubscription = combineLatest([
        this.loadInstancesWithConfigurationState(blueprintId),
        this.configService.getConfigurations(blueprintId)
      ])
        .pipe(
          takeUntilDestroyed(this.destroyRef))
          .subscribe(([instances, configurations]) => {
          const instanceId = this.activatedRoute.snapshot.params.instanceId;
          this.allInstances = instances;
          this.allInstances.forEach(instance => {
            if (instance.deploymentClass === DeploymentClass.D) {
              instance.environment = 'DEV';
            } else {
              instance.environment = this.blueprint?.pathToLiveConfiguration.find(item => item?.instanceId === instance?.id)?.environment;
            }
          });
          this.instance = this.allInstances.find(instance => instance.id === instanceId);
          this.configurations = configurations;
          if (initialLoad) {
            this.getRvtStates();
            this.loadConfigurations();
          }
          const availableConfigurations: any = this.getAvailableConfigurations(this.instance);
          availableConfigurations.forEach(config => {
            config.status = this.instance?.configurationStates?.find(item => item.configurationId === config.id)?.status;
            config.skipTest = this.instance?.configurationStates?.find(item => item.configurationId === config.id)?.skipTest;
          });
          this.availableConfigurations = availableConfigurations;
        }, () => this.errorPageService.show404Page());
    }
  }

  private getRvtStates(): void {
    // this.instanceService.getRVTStates(this.instance.id)
    // .pipe(takeUntilDestroyed(this.destroyRef))
    // .subscribe(rvtStates => {
    //   this.allRvtStates = rvtStates?.data;
    //   this.rvtResultsLoaded = true;
    //   if (this.allRvtStates?.find(config => config.status === ConfigurationApplicationStatus.TESTING)) {
    //     this.appliedRvtState = this.allRvtStates.find(config => config.status === ConfigurationApplicationStatus.TESTING);
    //   }
    //   if (this.allRvtStates.find(config => config.id === this.appliedRvtState?.id &&
    //     config.status === ConfigurationApplicationStatus.SUCCESS)) {
    //     this.selectedRvtTab = 1;
    //     this.executeRvtInProgress = false;
    //     this.loadRvtStates();
    //   }
    //   if (this.allRvtStates.find(config => config.id === this.appliedRvtState?.id &&
    //     config.status !== ConfigurationApplicationStatus.TESTING && config.status !== ConfigurationApplicationStatus.SUCCESS)) {
    //     this.executeRvtInProgress = false;
    //     this.loadRvtStates();
    //   }
    //   if (!this.instance || !this.allRvtStates) {
    //     return;
    //   }
    //   this.allRvtStates?.sort((state1, state2) => state2.applicationStartTime.getTime() - state1.applicationStartTime.getTime());
    //   this.instance.rvtStates = this.allRvtStates;
    //   if (this.instance.rvtStates?.length > 0) {
    //     this.instance.latestRvtState = this.instance.rvtStates[0];
    //   }
    //   const configurations = cloneDeep(this.configurations);
    //   this.configurationsForRvt = configurations?.filter(config => config?.manifest?.test);
    //   this.configurationsForRvt?.forEach(config => {
    //     config.status = this.allRvtStates?.find(item => item.configurationId === config.id)?.status;
    //   });
    //   this.configurationLoaded = true;
    //   this.loadRvtStates();
    // },
    // (error) => {
      this.configurationLoaded = true;
    //   this.toastrService.clear();
    //   setTimeout(() => {
    //     this.toastrService.errorMessage(
    //       `${error?.message ? error?.message : (error?.error?.message ? error?.error?.message
    //         : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')))}`
    //       );
    //   }, 500);
    // });
  }

  /**
   * Loads configuration states for all instances
   * @param - the blueprint id
   */
  private loadInstancesWithConfigurationState(blueprintId: string): Observable<Instance[]> {
    return this.instanceService.getInstancesForBlueprint(blueprintId)
      .pipe(mergeMap((instances) => {
        const instanceId = this.activatedRoute.snapshot.params.instanceId;
        this.instanceBlueprint = instances;
        const latestConfigRequests = this.instanceBlueprint
          .filter(instance => instance.configurationId)
          .map(instance => this.configService.getConfigurationStates(
            instance.id
          ));
        this.deployedDate = instances.length > 0 ? instances[instances.length - 1].dateUpdated : this.currentDate;
        if (latestConfigRequests.length > 0) {
          return combineLatest(latestConfigRequests).pipe(map(configurationStates => {
            if (configurationStates) {
              this.configResultsLoaded = true;
              configurationStates.forEach(configurationStatesForInstance => {
                if (configurationStatesForInstance?.length > 0) {
                  const instance = instances.find(inst => configurationStatesForInstance[0].instanceId === inst.id);
                  this.setInstanceConfigurationStates(instance, configurationStatesForInstance);
                }
              });
            }
            return instances;
          }));
        } else {
          this.configResultsLoaded = true;
        }
        return of(instances);
      }
      ));
  }

  /**
   * Sets configuration states for all instances
   * @param - instance and its configuration states
   */
  private setInstanceConfigurationStates(instance: Instance, configurationStates: ConfigurationState[]): void {
    if (instance?.id === this.instance?.id) {
      this.allConfigurationStates = configurationStates;
    }
    if (configurationStates.find(config => config.status === ConfigurationApplicationStatus.CONFIGURING ||
      config.status === ConfigurationApplicationStatus.VERIFYING)) {
      this.appliedConfigurationState = configurationStates.find(config => config.status === ConfigurationApplicationStatus.CONFIGURING);
    }
    if (configurationStates.find(config => config.id === this.appliedConfigurationState?.id &&
      config.status === ConfigurationApplicationStatus.SUCCESS)) {
      this.selectedTab = 1;
      this.loadConfigurations();
    }
    if (!instance || !configurationStates) {
      return;
    }
    configurationStates.sort((state1, state2) => state2.applicationStartTime.getTime() - state1.applicationStartTime.getTime());
    instance.configurationStates = configurationStates;
    if (instance.configurationStates?.length > 0) {
      instance.latestConfigurationState = instance.configurationStates[0];
    }
  }

  // Subscribes for notifications for updating the configuration states status accordingly
  private subscribeForNotifications(): void {
    this.notificationsService.onAnyNotification([
      { type: 'com.temenos.saas.engine.configuration' },
      { subject: 'Change Task', data: { status: 'published' } },
      { subject: 'Change Task', data: { status: 'rejected' } },
      { subject: 'Change Task', data: { status: 'applying' } },
      { subject: 'Change Task', data: { status: 'applied' } }
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        if (notification.data?.blueprintId === this.blueprint?.id) {
          this.loadData();
        }
      });

    this.notificationsService.onAnyNotification([
      { type: 'com.temenos.saas.engine.configuration.apply' },
      { type: 'com.temenos.saas.engine.configuration.verify' }
    ])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notification) => {
        const updatedInsance = this.allInstances?.find(instance => instance.id === notification.data?.instanceId);
        if (updatedInsance) {
          this.loadData();
        }
      });
  }

  onSupportClick(): void {
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');
  }

  private refreshInstanceForm(): void {
    this.isLoading = true;
    this.loadData(true);
    this.isLoading = false;

    this.count = this.count !== 1 ? 1 : 0;
    this.defaultState = true;
    this.defaultState = false;
  }

  private refreshMonitoring(): void {
    this.isLoading = true;
    this.selectedItem = null;
    this.filteredMonitoringTable = [];
    this.loadMonitoring();
  }
}